module.exports = __webpack_public_path__ + "img/thumb-worteltaart.725e95ae.jpg";